import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { ChangeControlTransactionLabels } from '../../models/change-control-transaction-labels';
import { PanelList } from '../../../../shared/models/panel-list';
import { ChangeControlDisplayDetails } from '../../models/change-control-display-details';
import { AssignmentDisplayDetails } from '../../models/assignment-display-details';
import { PhaseOwnerDetails } from '../../models/phase-owner-details';
import { ChangeControlService } from '../../../change-control-library/services/changecontrol.service';
import { catchError, throwError } from 'rxjs';
import { MessageService } from 'primeng/api';
import { ChangeManagementConstant } from '../../constants/changeManagementConstants';
import { AuthenticationHelperService } from '../../../../shared/components/authentication-maintainance/services/authentication-helper.service';
import { ChangeControlPersistenceService } from '../../services/change-control-persistence.service';
import { ChangeControlConstants } from '../../constants/changeControlConstants';
import { SpinnerService } from '../../../../shared/services/spinner.service';
import { CommonService } from '../../../../shared/services/common.service';

@Component({
  selector: 'app-change-control-phase-update-by-phaseOwners',
  templateUrl: './change-control-phase-update-by-phaseOwners.component.html',
  styleUrls: ['./change-control-phase-update-by-phaseOwners.component.scss'],
})
export class ChangeControlPhaseUpdateByPhaseOwnersComponent implements OnInit {
  @Output() isTransactionModalVisible = new EventEmitter<boolean>();
  @Output() updateChangeControlDispalyDetails =
    new EventEmitter<ChangeControlDisplayDetails>();
  @Input() changeControlDetails!: ChangeControlDisplayDetails;
  changeControlTransactionLabels!: ChangeControlTransactionLabels;
  phaseOwnerDetails: PhaseOwnerDetails = {} as PhaseOwnerDetails;
  transactionSuccessMessageText: string = '';
  showTargetCompletionDateModal: boolean = false;
  showEsignatureConfirmationDialog: boolean = false;
  confirmationMessage: string = '';

  display: boolean = true;
  showLoader: boolean = false;
  isDataAvailable: boolean = true;
  ccAssignmentDetails: AssignmentDisplayDetails =
    {} as AssignmentDisplayDetails;
  panelListData: PanelList = {
    lists: [],
    filters: [],
    sort: [],
    enableFilter: true,
    enableSort: true,
  };

  constructor(
    private changeControlService: ChangeControlService,
    private messageService: MessageService,
    private readonly authenticationHelperService: AuthenticationHelperService,
    private changeControlPersistenceService: ChangeControlPersistenceService,
    private changeDetectorRef: ChangeDetectorRef,
    private spinnerService: SpinnerService,
    private commonService: CommonService
  ) {}
  ngOnInit() {
    this.showLoader = true;
    this.loadUserDetails();
  }

  loadUserDetails = () => {
    switch (this.changeControlDetails.phase) {
      case 1:
        this.confirmationMessage =
          ChangeControlConstants.ChangeControl_Review_Confirmation_Message;
        this.loadReviewersDetails();
        break;
      case 2:
        this.confirmationMessage =
          ChangeControlConstants.ChangeControl_Approval_Confirmation_Message;
        this.loadApproversDetails();
        break;
      case 4:
        this.confirmationMessage =
          ChangeControlConstants.ChangeControl_Verifier_Confirmation_Message;
        this.loadVerifiersDetails();
        break;
      default:
        break;
    }
    this.addFilters(this.changeControlDetails.phase);
    this.addSorting(this.changeControlDetails.phase);
    this.showLoader = false;
  };

  loadReviewersDetails = () => {
    this.changeControlTransactionLabels = new ChangeControlTransactionLabels(
      'Review Status',
      'Reviewer',
      'Status',
      'Reviewed Date'
    );
    this.panelListData.lists =
      this.changeControlDetails.reviewers.length > 0
        ? this.changeControlDetails.reviewers
        : [];
    this.isDataAvailable = this.panelListData.lists.length > 0;
    this.transactionSuccessMessageText =
      ChangeManagementConstant.ReviewStatusUpdated_Success;
  };
  loadApproversDetails = () => {
    this.changeControlTransactionLabels = new ChangeControlTransactionLabels(
      'Approval Status',
      'Approver',
      'Status',
      'Approved Date'
    );
    this.panelListData.lists =
      this.changeControlDetails.approvers.length > 0
        ? this.changeControlDetails.approvers
        : [];
    this.transactionSuccessMessageText =
      ChangeManagementConstant.ApprovalStatusUpdated_Success;
  };

  loadVerifiersDetails = () => {
    this.changeControlTransactionLabels = new ChangeControlTransactionLabels(
      'Verification Status',
      'Verifier',
      'Status',
      'Verified Date'
    );
    // load verifier details
    this.panelListData.lists =
      this.changeControlDetails.verifiers.length > 0
        ? this.changeControlDetails.verifiers
        : [];
    this.isDataAvailable = this.panelListData.lists.length > 0;
    this.transactionSuccessMessageText =
      ChangeManagementConstant.VerificationStatusUpdated_Success;
  };
  addFilters = (phaseId: number): void => {
    this.panelListData.filters?.push({
      filterDisplayName: 'Status',
      filterFieldName: 'statusName',
    });

    if (phaseId === 1) {
      this.panelListData.filters?.push({
        filterDisplayName: 'Reviewer',
        filterFieldName: 'name',
      });
    } else if (phaseId === 2) {
      this.panelListData.filters?.push({
        filterDisplayName: 'Approver',
        filterFieldName: 'name',
      });
    } else if (phaseId === 4) {
      this.panelListData.filters?.push({
        filterDisplayName: 'Verifier',
        filterFieldName: 'name',
      });
    }
  };
  addSorting = (phaseId: number): void => {
    this.panelListData.sort?.push({
      sortFieldDisplayName: 'Status',
      sortFieldName: 'statusName',
    });

    if (phaseId === 1) {
      this.panelListData.sort?.push({
        sortFieldDisplayName: 'Approver',
        sortFieldName: 'name',
      });
    } else if (phaseId === 2) {
      this.panelListData.sort?.push({
        sortFieldDisplayName: 'Reviewer',
        sortFieldName: 'name',
      });
    } else if (phaseId === 4) {
      this.panelListData.sort?.push({
        sortFieldDisplayName: 'Verifier',
        sortFieldName: 'name',
      });
    }
  };

  closeTransactionModal = () => {
    this.isTransactionModalVisible.emit(false);
  };
  updateStatus(data: AssignmentDisplayDetails) {
    this.ccAssignmentDetails = data;
    this.showEsignatureConfirmationDialog = true;
  }

  updateChangeControlPhaseByPhaseOwners = () => {
    this.spinnerService.show();
    this.changeControlService
      .updateChangeControlPhaseByPhaseOwners(this.phaseOwnerDetails)
      .pipe(
        catchError((err) => {
          this.spinnerService.hide();
          this.messageService.add({
            severity: ChangeManagementConstant.Severity_Err,
            summary: `${err.error}`,
          });
          this.display = false;
          this.changeDetectorRef.detectChanges();
          return throwError(() => err);
        })
      )
      .subscribe((serviceData: ChangeControlDisplayDetails) => {
        this.spinnerService.hide();
        this.messageService.add({
          severity: ChangeManagementConstant.Severity_Info,
          summary: `${this.transactionSuccessMessageText}`,
        });
        this.updateChangeControlDispalyDetails.emit(serviceData);
        this.changeControlPersistenceService.actionPlanDataUpdated.next(true);
        this.changeControlPersistenceService.updateChangeControlView();
        this.display = false;
        this.changeDetectorRef.detectChanges();
      });
  };
  openTargetCompletionDateModal = () => {
    this.showTargetCompletionDateModal = true;
  };
  closeTargetCompletionDateModal = (event: boolean) => {
    this.showTargetCompletionDateModal = !event;
  };
  updateTargetCompletionDate = (event: Date | null) => {
    this.showTargetCompletionDateModal = false;
    this.phaseOwnerDetails.targetCompletionDate = event ? this.commonService.convertDateIfChanged(new Date(event), new Date(this.changeControlDetails.targetCompletionDate as Date)) : null;
    this.authenticationHelperService.reauth(
      this.updateChangeControlPhaseByPhaseOwners.bind(this),
      () => {}
    );
  };

  closeConfirmationModal() {
    this.showEsignatureConfirmationDialog = false;
  }
  onConfirm() {
    this.phaseOwnerDetails.number = this.changeControlDetails.number;
    this.phaseOwnerDetails.user = this.ccAssignmentDetails.name;
    this.changeControlDetails.phase === 2 && this.ccAssignmentDetails.isLastPhaseOwner
      ? this.openTargetCompletionDateModal()
      : this.authenticationHelperService.reauth(
          this.updateChangeControlPhaseByPhaseOwners.bind(this),
          () => {}
        );
  }
}
